import * as React from 'react'
import { fromJSX } from 'widgets-for-react'
import { styleguideChapter } from '../helpers.mod'

export const styleguideAbout = styleguideChapter({ type: 'about', slug: 'about', title: 'About', intro: '' })(
      fromJSX(
        () => (
          <>
            <p className="styleguide-chapter__intro styleguide--styled">
              This styleguide contains all components used on the Refresco Corporate website.
            </p>
          </>
        )
      )
    )
